
import { handleAxiosException, handleAxiosExceptionOnBlobType } from '@/api'
import { FindByIdMyArqanaHorseRegistrationDto, GetMyFileMyArqanaPedigreeDto, myRegistrationApi } from '@/api/auth/myHorseRegistration'
import ErrorAlert from '@/components/alert/ErrorAlert.vue'
import TitlePage from '@/components/TitlePage.vue'
import snackbarStore from '@/store/snackbarStore'
import { formatDate } from '@/utils/dates'
import { getDocumentStateLabel, getDocumentStateIcon } from '@/utils/documentStates'
import Vue from 'vue'
import { formatISO } from 'date-fns'
import RegistrationStepper from '../RegistrationStepper.vue'

export default Vue.extend({
  components: { RegistrationStepper, ErrorAlert, TitlePage },
  props: {
    registrationId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      errorLoading: '',
      downloadingOriginal: false,
      downloadingPedigree: false,
      registration: {} as FindByIdMyArqanaHorseRegistrationDto,
      error: '',
      sending: false,
      accepting: false,
      pedigreeFile: undefined as File | undefined,
      pedigreeMetadata: [{}] as GetMyFileMyArqanaPedigreeDto[],
      originalPedigreeAccepted: false,
      successSave: false,
      errorSave: false,
    }
  },
  methods: {
    getDocumentStateLabel,
    getDocumentStateIcon,
    async downloadPedigree() {
      this.error = ''
      this.downloadingPedigree = true
      try {
        const pedigreeRequests = (await myRegistrationApi.getPedigree(this.registrationId))
        window.open(pedigreeRequests[0].downloadUrl)
      } catch (e) {
        this.error = this.$t(handleAxiosException(e)) as string
      }
      this.downloadingPedigree = false
    },
    async downloadArqanaPedigree() {
      this.error = ''
      this.downloadingOriginal = true
      if (this.pedigreeExist) {
        try {
          await myRegistrationApi.downloadOriginalPedigreePdf(this.registrationId)
        } catch (err) {
          snackbarStore.setError(await handleAxiosExceptionOnBlobType(err))
        }
      }
      this.downloadingOriginal = false
    },
    async sendPedigree() {
      this.error = ''
      this.sending = true
      try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        await myRegistrationApi.sendPedigree(this.registrationId, this.pedigreeFile!, this.pedigreeMetadata[0].pedigreeChangeRequest ?? '')
        snackbarStore.setSnackbar({ text: this.$t('success_send') as string, color: 'success' })
        // this.pedigreeFile = undefined
        // this.pedigreeMetadata.downloadUrl = 'justSent'
        // this.pedigreeMetadata.lastPedigreeUpload = new Date().toISOString()
        // this.pedigreeMetadata.currentStatus = 'WAITING'
        this.load()
      } catch (e) {
        this.error = this.$t(handleAxiosException(e)) as string
      } finally {
        this.sending = false
      }
    },
    async load() {
      this.error = ''
      this.loading = true
      try {
        await Promise.all([
          myRegistrationApi.getPedigree(this.registrationId).then(((r) => {
            this.pedigreeMetadata = r
          })),
          myRegistrationApi.findById(this.registrationId).then((r) => {
            this.registration = r
          }),
        ])
        if (!this.openValidation) {
          this.$router.push({
            name: 'Prochaines inscriptions',
          })
        }
      } catch (e) {
        this.errorLoading = this.$t(handleAxiosException(e)) as string
      }
      this.loading = false
    },
    // async sendChangeRequest() {
    //   try {
    //     await myRegistrationApi.sendChangeRequest(this.registrationId, this.pedigreeMetadata.pedigreeChangeRequest ?? '')
    //     this.successSave = true
    //     this.pedigreeMetadata.currentStatus = 'WAITING'
    //   } catch (e) {
    //     this.errorSave = true
    //   }
    // },
    async acceptArqanaPedigree() {
      this.accepting = true
      try {
        this.originalPedigreeAccepted = await myRegistrationApi.acceptOriginalPedigree(this.registrationId, !this.originalPedigreeAccepted)
        this.registration = await myRegistrationApi.findById(this.registrationId)
      } catch (e) {
        this.errorSave = true
      }
      this.accepting = false
    },
    formatDate,
  },
  computed: {
    pedigreeName(): string {
      return `pedigree_${this.registration.name}.docx`
    },
    openValidation(): boolean {
      if (this.registration?.technicalSale) {
        const dateNow = formatISO(new Date(), { representation: 'date' })
        return dateNow <= this.registration.technicalSale.correctionsEnd && dateNow >= this.registration.technicalSale.correctionsStart
      }
      return false
    },
    pedigreeExist(): boolean {
      return this.registration?.pedigreeAvailable && this.registration?.pedigreeUploaded || false
    },
  },
  mounted() {
    this.load()
  },
})
